const dynamicCoursesWithFiltersApp = Vue.createApp({
    data() {
        return {
            courses: typeof coursesWithFilters !== 'undefined' ? coursesWithFilters : [],
            thumbnailMap: typeof cwfThumbnailMap !== 'undefined' ? cwfThumbnailMap : {},
            thumbnailPlaceholder: typeof cwfThumbnailPlaceholder !== 'undefined' ? cwfThumbnailPlaceholder : '',
            tagLabelMap: typeof cwfTagLabelMap !== 'undefined' ? cwfTagLabelMap : {},
            coursePage: 1,
            coursePerPage: typeof numberOfCoursesWithFiltersPerPage !== 'undefined' ? numberOfCoursesWithFiltersPerPage : 6,
            coursePages: [],
            totalNumberofCoursePages: 0,
            selectedDelivery: [],
            selectedTopics: [],
            dateRangeOptions: ['This Week', 'Next Week', 'This Month', 'Next Month', 'Next 3 Months'],
            isDateDropdownOpen: false,
            dateDropdownPanelStyle: { position: 'fixed', top: '0px', left: '0px', width: 'auto' },
            selectedDateOption: '',
            pendingDateOption: '',
            customStartDate: '',
            customEndDate: '',
            pendingCustomStartDate: '',
            pendingCustomEndDate: '',
            dateFilterSkus: [],
            dateFilterBounds: null,
            customRangeError: '',
            searchQuery: '',
            searchSkus: null,
            searchLoading: false,
            searchDebounceTimer: null,
            searchRequestSeq: 0,
            isApplyingFiltersFromUrl: false,
            filtersExpanded: true,
            keyTopics: typeof cwfKeyTopics !== 'undefined' && Array.isArray(cwfKeyTopics) && cwfKeyTopics.length > 0
                ? cwfKeyTopics
                : []
        };
    },

    methods: {
        ...CourseCardMethods,

        setCoursePages(courses) {
            this.coursePages = [];
            this.totalNumberofCoursePages = Math.ceil(courses.length / this.coursePerPage);
            this.coursePages = pagination(this.coursePage, this.totalNumberofCoursePages);
        },

        paginate(items, page, perPage) {
            let from = (page * perPage) - perPage;
            let to = page * perPage;
            return items.slice(from, to);
        },

        resetPages() {
            this.coursePage = 1;
        },

        searchKey(item) {
            return item.partner_Product__c ? item.cmS_Dummy_SKU__c : item.sku;
        },

        matchesSearch(item) {
            const q = this.searchQuery.trim();
            if (!q) return true;

            // Results pending (or search failed) — keep the current list until the server responds.
            if (this.searchSkus === null) return true;

            const skuKey = this.searchKey(item);
            return !!skuKey && this.searchSkus.includes(skuKey);
        },

        fetchSearchSkus() {
            const q = this.searchQuery.trim();

            if (!q) {
                this.searchSkus = null;
                this.searchLoading = false;
                return;
            }

            this.searchLoading = true;

            const requestSeq = ++this.searchRequestSeq;

            fetch('/courses/search-skus?q=' + encodeURIComponent(q))
                .then(response => response.ok ? response.json() : null)
                .then(data => {
                    // Ignore out-of-order responses from earlier keystrokes.
                    if (requestSeq !== this.searchRequestSeq) return;
                    this.searchSkus = data ? (data.skus || []) : [];
                    this.searchLoading = false;
                    this.resetPages();
                })
                .catch(() => {
                    if (requestSeq !== this.searchRequestSeq) return;
                    this.searchSkus = [];
                    this.searchLoading = false;
                });
        },

        updateDateDropdownPosition() {
            const triggerEl = this.$refs.dateDropdown;
            if (!triggerEl) return;

            const rect = triggerEl.getBoundingClientRect();

            if (this.isDateDropdownOpen) {
                const headerEl = document.getElementById('header');
                const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;

                if (rect.bottom < headerBottom || rect.top > window.innerHeight) {
                    this.cancelDateFilter();
                    return;
                }
            }

            const gap = 6;

            const panelEl = this.$refs.dateDropdownPanel;
            const panelHeight = panelEl ? panelEl.getBoundingClientRect().height : 0;
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            const openUpward = panelHeight > 0 && spaceBelow < panelHeight + gap && spaceAbove > spaceBelow;

            this.dateDropdownPanelStyle = openUpward
                ? {
                    position: 'fixed',
                    bottom: (window.innerHeight - rect.top + gap) + 'px',
                    left: rect.left + 'px',
                    width: rect.width + 'px'
                }
                : {
                    position: 'fixed',
                    top: (rect.bottom + gap) + 'px',
                    left: rect.left + 'px',
                    width: rect.width + 'px'
                };
        },

        toggleDateDropdown() {
            if (this.isDateDropdownOpen) {
                this.cancelDateFilter();
                return;
            }

            this.pendingDateOption = this.selectedDateOption;
            this.pendingCustomStartDate = this.customStartDate;
            this.pendingCustomEndDate = this.customEndDate;
            this.customRangeError = '';
            this.updateDateDropdownPosition();
            this.isDateDropdownOpen = true;

            this.$nextTick(() => {
                this.updateDateDropdownPosition();
            });
        },

        cancelDateFilter() {
            this.isDateDropdownOpen = false;
            this.customRangeError = '';
        },

        clearDateFilter() {
            this.selectedDateOption = '';
            this.pendingDateOption = '';
            this.customStartDate = '';
            this.customEndDate = '';
            this.pendingCustomStartDate = '';
            this.pendingCustomEndDate = '';
            this.dateFilterSkus = [];
            this.dateFilterBounds = null;
            this.customRangeError = '';
            this.isDateDropdownOpen = false;

            this.resetPages();
            this.updateUrlWithFilters();
            scrollOnPagination('dynamicCoursesWithFilters');
        },

        applyDateFilter() {
            if (this.pendingDateOption === 'Custom') {
                if (!this.pendingCustomStartDate || !this.pendingCustomEndDate) {
                    this.customRangeError = 'Please select both a start and end date.';
                    return;
                }

                if (new Date(this.pendingCustomEndDate) < new Date(this.pendingCustomStartDate)) {
                    this.customRangeError = 'End date must be on or after the start date.';
                    return;
                }

                this.customRangeError = '';
                this.selectedDateOption = 'Custom';
                this.customStartDate = this.pendingCustomStartDate;
                this.customEndDate = this.pendingCustomEndDate;
                this.fetchDateRangeSkus({ startDate: this.customStartDate, endDate: this.customEndDate });
            } else {
                this.selectedDateOption = this.pendingDateOption;
                this.customStartDate = '';
                this.customEndDate = '';
                this.customRangeError = '';
                this.fetchDateRangeSkus({ preset: this.pendingDateOption });
            }

            this.isDateDropdownOpen = false;
            this.resetPages();
            this.updateUrlWithFilters();
            scrollOnPagination('dynamicCoursesWithFilters');
        },

        fetchDateRangeSkus({ preset, startDate, endDate } = {}) {
            let url = '/courses/date-range-skus?';

            if (preset) {
                url += 'preset=' + encodeURIComponent(preset);
            } else if (startDate && endDate) {
                url += 'startDate=' + encodeURIComponent(startDate) + '&endDate=' + encodeURIComponent(endDate);
            } else {
                this.dateFilterSkus = [];
                this.dateFilterBounds = null;
                return;
            }

            fetch(url)
                .then(response => response.ok ? response.json() : null)
                .then(data => {
                    this.dateFilterSkus = (data && Array.isArray(data.skus)) ? data.skus : [];
                    this.dateFilterBounds = (data && data.start && data.end) ? { start: data.start, end: data.end } : null;
                })
                .catch(() => {
                    this.dateFilterSkus = [];
                    this.dateFilterBounds = null;
                });
        },

        parseLocalDate(dateStr) {
            const parts = dateStr.split('-').map(Number);
            return new Date(parts[0], parts[1] - 1, parts[2]);
        },

        formatDateRange(startStr, endStr) {
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            const startText = this.parseLocalDate(startStr).toLocaleDateString('en-US', options);
            const endText = this.parseLocalDate(endStr).toLocaleDateString('en-US', options);
            return startText + ' - ' + endText;
        },

        handleClickOutsideDateDropdown(event) {
            if (!this.isDateDropdownOpen) return;

            const triggerEl = this.$refs.dateDropdown;
            const panelEl = this.$refs.dateDropdownPanel;

            if ((triggerEl && triggerEl.contains(event.target)) || (panelEl && panelEl.contains(event.target))) {
                return;
            }

            this.cancelDateFilter();
        },

        handleWindowScrollForDateDropdown() {
            if (this.isDateDropdownOpen) {
                this.updateDateDropdownPosition();
            }
        },

        toggleFiltersExpanded() {
            this.filtersExpanded = !this.filtersExpanded;
        },

        matchesDateRange(item) {
            if (!this.selectedDateOption) return true;

            const skuKey = item.partner_Product__c ? item.cmS_Dummy_SKU__c : item.sku;
            if (!skuKey) return false;

            return this.dateFilterSkus.includes(skuKey);
        },

        sanitizeValue(val) {
            if (val === null || val === undefined) return '';
            return String(val).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        },

        clearSearch() {
            this.searchQuery = '';
        },

        resetFilters() {
            this.selectedDelivery = [];
            this.selectedTopics = [];
            this.selectedDateOption = '';
            this.pendingDateOption = '';
            this.customStartDate = '';
            this.customEndDate = '';
            this.pendingCustomStartDate = '';
            this.pendingCustomEndDate = '';
            this.dateFilterSkus = [];
            this.dateFilterBounds = null;
            this.customRangeError = '';
            this.isDateDropdownOpen = false;
            this.searchQuery = '';

            document.querySelectorAll('input[name="cwfDeliveryFilter"]').forEach(input => {
                input.checked = false;
            });
            document.querySelectorAll('input[name="cwfTopicFilter"]').forEach(input => {
                input.checked = false;
            });

            this.updateUrlWithFilters();
        },

        updateUrlWithFilters() {
            if (this.isApplyingFiltersFromUrl) return;

            let params = new URLSearchParams(window.location.search || '');

            if (this.selectedDelivery.length > 0) {
                params.set('delivery', this.selectedDelivery.map(d => this.sanitizeValue(d)).join(' '));
            } else {
                params.delete('delivery');
            }

            if (this.selectedTopics.length > 0) {
                params.set('topic', this.selectedTopics.map(t => this.sanitizeValue(t)).join(' '));
            } else {
                params.delete('topic');
            }

            if (this.selectedDateOption) {
                params.set('daterange', this.sanitizeValue(this.selectedDateOption));
            } else {
                params.delete('daterange');
            }

            if (this.selectedDateOption === 'Custom' && this.customStartDate) {
                params.set('datestart', this.customStartDate);
            } else {
                params.delete('datestart');
            }

            if (this.selectedDateOption === 'Custom' && this.customEndDate) {
                params.set('dateend', this.customEndDate);
            } else {
                params.delete('dateend');
            }

            if (this.searchQuery.trim().length > 0) {
                params.set('search', this.searchQuery.trim());
            } else {
                params.delete('search');
            }

            let newUrl = window.location.pathname;
            const query = params.toString();
            if (query.length > 0) {
                newUrl += '?' + query;
            }

            if (window.location.hash) {
                newUrl += window.location.hash;
            }

            window.history.pushState(null, '', newUrl);
        },

        applyFiltersFromUrl() {
            this.isApplyingFiltersFromUrl = true;
            const params = new URLSearchParams(window.location.search);

            let paramMap = {};
            for (const [key, value] of params.entries()) {
                paramMap[key.toLowerCase()] = value;
            }

            const delivery = paramMap['delivery'];
            if (delivery) {
                delivery.split(' ').forEach(val => {
                    document.querySelectorAll('input[name="cwfDeliveryFilter"]').forEach(input => {
                        if (this.sanitizeValue(input.value) === val.toLowerCase()) {
                            if (!this.selectedDelivery.includes(input.value)) {
                                this.selectedDelivery.push(input.value);
                            }
                        }
                    });
                });
            }

            const topic = paramMap['topic'];
            if (topic) {
                topic.split(' ').forEach(val => {
                    const matched = this.availableTopics.find(t => this.sanitizeValue(t) === val.toLowerCase());
                    if (matched && !this.selectedTopics.includes(matched)) {
                        this.selectedTopics.push(matched);
                    }
                });
            }

            const daterange = paramMap['daterange'];
            if (daterange) {
                if (daterange.toLowerCase() === this.sanitizeValue('Custom')) {
                    const dateStart = paramMap['datestart'];
                    const dateEnd = paramMap['dateend'];
                    if (dateStart && dateEnd) {
                        this.selectedDateOption = 'Custom';
                        this.customStartDate = dateStart;
                        this.customEndDate = dateEnd;
                        this.fetchDateRangeSkus({ startDate: dateStart, endDate: dateEnd });
                    }
                } else {
                    const matched = this.dateRangeOptions.find(d => this.sanitizeValue(d) === daterange.toLowerCase());
                    if (matched) {
                        this.selectedDateOption = matched;
                        this.fetchDateRangeSkus({ preset: matched });
                    }
                }
            }

            const search = paramMap['search'];
            if (search) {
                this.searchQuery = search;
            }

            this.updateUrlWithFilters();
            this.isApplyingFiltersFromUrl = false;
        }
    },

    computed: {
        hideNextSession() {
            return !!this.selectedDateOption;
        },

        filtersApplied() {
            return this.selectedDelivery.length > 0
                || this.selectedTopics.length > 0
                || !!this.selectedDateOption
                || this.searchQuery.trim().length > 0;
        },

        dateFilterLabel() {
            if (!this.selectedDateOption) return 'Date';

            if (this.selectedDateOption === 'Custom') {
                return (this.customStartDate && this.customEndDate)
                    ? (this.customStartDate + ' - ' + this.customEndDate)
                    : 'Custom';
            }

            return this.selectedDateOption;
        },

        dateFilterRangeText() {
            if (!this.selectedDateOption || !this.dateFilterBounds) return '';

            return this.formatDateRange(this.dateFilterBounds.start, this.dateFilterBounds.end);
        },

        rawTopics() {
            let topics = [];
            this.courses.forEach(course => {
                topics = topics.concat(course.practiceArea || []);
            });
            return topics.filter((item, i, ar) => ar.indexOf(item) === i);
        },

        availableTopics() {
            const keyList = [];
            let hasOther = false;

            this.rawTopics.forEach(topic => {
                if (this.keyTopics.includes(topic)) {
                    keyList.push(topic);
                } else {
                    hasOther = true;
                }
            });

            if (hasOther) {
                keyList.push('Other');
            }

            return keyList;
        },

        filteredCourses() {
            const filtered = this.courses.filter(function (item) {
                return (
                    this.matchesSearch(item)
                    &&
                    (this.selectedDelivery.length === 0 || this.selectedDelivery.some(d => (item.productType || []).includes(d)))
                    &&
                    (this.selectedTopics.length === 0 || this.selectedTopics.some(topic => {
                        if (topic === 'Other') {
                            return (item.practiceArea || []).some(pa => !this.keyTopics.includes(pa));
                        }
                        return (item.practiceArea || []).includes(topic);
                    }))
                    &&
                    this.matchesDateRange(item)
                );
            }, this);

            if (this.searchQuery.trim() && this.searchSkus !== null) {
                const rank = new Map(this.searchSkus.map((sku, index) => [sku, index]));
                filtered.sort((a, b) => rank.get(this.searchKey(a)) - rank.get(this.searchKey(b)));
            }

            return filtered;
        },

        displayedCourses() {
            this.setCoursePages(this.filteredCourses);
            return this.paginate(this.filteredCourses, this.coursePage, this.coursePerPage);
        }
    },

    watch: {
        availableTopics(newTopics) {
            if (this.selectedTopics.length > 0) {
                this.selectedTopics = this.selectedTopics.filter(t => newTopics.includes(t));
            }
        },

        selectedDelivery() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }
            scrollOnPagination('dynamicCoursesWithFilters');
        },

        selectedTopics() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }
            scrollOnPagination('dynamicCoursesWithFilters');
        },

        searchQuery() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }

            // Debounced server search (shared Azure content search) — same results as the mobile API.
            clearTimeout(this.searchDebounceTimer);

            if (!this.searchQuery.trim()) {
                this.searchSkus = null;
                this.searchLoading = false;
                this.searchRequestSeq++;
                return;
            }

            this.searchDebounceTimer = setTimeout(() => this.fetchSearchSkus(), 350);
        },

        coursePage() {
            scrollOnPagination('dynamicCoursesWithFilters');
        }
    },

    mounted() {
        this.applyFiltersFromUrl();
        this.filtersExpanded = !window.matchMedia('(max-width: 991.98px)').matches;
        document.addEventListener('click', this.handleClickOutsideDateDropdown);
        window.addEventListener('scroll', this.handleWindowScrollForDateDropdown, true);
        window.addEventListener('resize', this.handleWindowScrollForDateDropdown);
    }
});

const dynamicCoursesWithFiltersMountedApp = dynamicCoursesWithFiltersApp.mount('#dynamicCoursesWithFilters');
